import {AutoplayView} from '@gongxigames/framework/slot/modules/autoplay/AutoplayView';
import {KeypadView} from '@gongxigames/framework/slot/modules/keypad/KeypadView';
import {KeypadViewMobileLandscape} from '@gongxigames/framework/slot/modules/keypad/KeypadViewMobileLandscape';
import {Sprite} from 'pixi.js';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {DeviceType, Text, Button, State} from '@gongxigames/framework/core';

export class AutoplayViewMobileLandscape extends AutoplayView {
    public static readonly NAME: symbol = Symbol('AutoplayViewMobileLandscape');
    public static layer = LAYERS.KEYPAD;
    public static platform: DeviceType = DeviceType.MOBILE;

    protected _spinButton!: Button;

    public init(): void {
        this.initGraphicElements();
    }

    protected initGraphicElements(): void {
        super.initGraphicElements();

        this._spinButton = this.mainSprite.getChildByName<Button>('spinButton');
    }

    public stopAutoplayButtonClickAction(): void {
        this._stopAutoplayButton.visible = false;
    }

    public setAutoplayFieldText(text: string): void {
        for (const frameKey in this._stopAutoplayButton.frames) {
            if (this._stopAutoplayButton.frames.hasOwnProperty(frameKey)) {
                const frame = this._stopAutoplayButton.frames[frameKey as State];
                const field = (frame as Sprite).getChildByName<Text>('spinsAmountField');

                field.visible = true;
                field.text = text;
            }
        }
    }

    protected get mainSprite(): Sprite {
        return this._installer.getComponent<KeypadView>(KeypadViewMobileLandscape.NAME).mainSprite;
    }

    public getViewDependencies(): (symbol|string)[] {
        return [KeypadViewMobileLandscape.NAME];
    }
}
